import React, { memo } from 'react'
import moment from 'moment'
import './NotificationCard.css'

const NotificationCard = ({
    item,
    onPress
}) => {

    const onPressNotification = () => {
        onPress(item);
    }

    return (
        <div 
            className="notification-card"
            onClick={onPressNotification}
        >
            <div className="notification-card__row">
                <span className="notification-card__value">{item?.title}</span>
            </div>
            <div className="notification-card__row">
                <span className="notification-card__value">{item?.body}</span>
            </div>
            <div className="notification-card__row">
                <span className="notification-card__value">{moment(item?.created_at).format('YYYY-MM-DD')}</span>
            </div>
        </div>
    )
}

export default memo(NotificationCard)